import { alert_chat } from '../services';
import { loadInsights } from './insights';
import { uid } from './utils';

const abortError = () => Object.assign(new Error('Aborted'), { name: 'AbortError' });

const failure = (message) => Object.assign(new Error(message || 'Request failed'), { userMessage: message });

export function createNovaApi() {
    return {
        async sendMessage(question, signal) {
            let res;
            try {
                res = await alert_chat({ organization_id: Number(localStorage.getItem('organization_id')), question });
            } catch (error) {
                throw failure(error?.response?.data?.error?.message);
            }
            if (signal?.aborted) throw abortError();

            const body = res?.statusCode?.response_data;
            if (body?.status_code !== 200) throw failure(res?.statusCode?.error?.message);

            const { response = '', remaining_credits: credits } = body.data || {};
            if (!response.trim()) throw failure();
            return {
                message: {
                    id: uid(),
                    role: 'assistant',
                    text: response.replace(/```markdown\n([\s\S]*?)```/, '$1'),
                    createdAt: new Date().toISOString(),
                },
                remainingCredits: typeof credits === 'number' ? credits : null,
            };
        },

        getInsights: loadInsights,
    };
}
